export default "__VITE_ASSET__q$kX3HJK__"